export const backgroundConfig: { [key: string]: { propValue: string; darkContrast: boolean } } = {
  "Brand Light": {
    propValue: "brandLight",
    darkContrast: false,
  },
  "Brand Mid": {
    propValue: "brandMid",
    darkContrast: true,
  },
  Grey: {
    propValue: "grey",
    darkContrast: false,
  },
  Black: {
    propValue: "black",
    darkContrast: true,
  },
};
